"use client";

import { FC, useEffect, useState } from "react";
import { formatTime } from "../(utils)/formatTime";

import Spinner from "../../../public/images/spinner.svg";
import { Button } from "./Button";

type Props = {
  isLoading: boolean;
  text: string;
  type: "button" | "submit" | "reset";
  className?: string;
  disabled?: boolean;
  submitCount: number;
  delayText: string;
  afterDelayText: string;
  error: any;
  serverError: string;
  isValid: boolean;
};

const waitValueInMs = 60000;
const waitValueInSec = waitValueInMs / 1000;

const DelayButton: FC<Props> = ({
  isLoading,
  text,
  type,
  submitCount,
  delayText,
  afterDelayText,
  ...rest
}) => {
  const [delayCounter, setDelayCounter] = useState(0);
  const [isDelayActive, setIsDelayActive] = useState(false);
  const withError = Object.keys(rest.error).length > 0;
  
  useEffect(() => {
    if (submitCount > 0 && !withError && rest.serverError.length === 0) {
      setIsDelayActive(true);
      setDelayCounter(waitValueInSec);
    }
  }, [submitCount, withError, rest.serverError.length]);

  useEffect(() => {
    if (delayCounter > 0) {
      const timer = setTimeout(() => setDelayCounter((val) => val - 1), 1000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [delayCounter]);

  useEffect(() => {
    if (delayCounter === 0 && isDelayActive) {
      setIsDelayActive(false);
    }
  }, [delayCounter, isDelayActive]);

  return (
    <Button
      disabled={isLoading || rest.disabled || delayCounter > 0 || withError}
      disableCount={delayCounter > 0}
      type={type}
      {...rest}
    >
      {isLoading ? (
        <Spinner
          className="animate-spin"
          alt="spinner"
        />
      ) : (
        <span>
          {delayCounter === 0 && !isDelayActive && text}
          {delayCounter > 0 && !withError && (
            <span>
              {delayText}
              &nbsp;
              {formatTime(delayCounter)}
            </span>
          )}
          {delayCounter === 0 && isDelayActive && afterDelayText}
        </span>
      )}
    </Button>
  );
};

export { DelayButton };
